export default __webpack_public_path__ + "static/media/bike-bmx.f55cd543.svg";